import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

/**
 * Folie 28 — Bonusarten.
 * Left column: 5 vertically stacked bonus rows, each with original PPTX SVG icon
 * (image77-81) + name + big value + short description.
 * Right column: aspirational business hero photo (image74).
 */
const ICONS = {
  unilevel: '/source-pptx/image80.svg', // GroupOfPeople
  infinity: '/source-pptx/image81.svg', // Hierarchy
  matching: '/source-pptx/image79.svg', // Completed / check
  world:    '/source-pptx/image77.svg', // Earth globe
  rank:     '/source-pptx/image78.svg', // Aspiration / trophy
};

export default function SectionBusiness() {
  const { t } = useT();
  return (
    <SectionShell id="business" className="business-compact">
      <div className="mb-2 md:mb-3">
        <Reveal>
          <div className="overline mb-3">{t.business.overline}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-white max-w-none">
            {t.business.title}
          </h2>
          <p className="business-sub font-ui text-white/80 leading-relaxed mt-3">
            {t.business.sub}
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
        {/* LEFT — 5 stacked bonus cards */}
        <div className="col-span-12 md:col-span-7">
          <div className="space-y-2.5" data-testid="bonus-list">
            {t.business.bonuses.map((b, i) => (
              <Reveal key={i} delay={80 + i * 90}>
                <div data-testid={`bonus-${i}`} className="bonus-card group">
                  <div className="bonus-card-inner">
                    <div className="bonus-icon">
                      <img
                        src={ICONS[b.icon]}
                        alt=""
                        aria-hidden
                        draggable={false}
                        className="w-5 h-5 md:w-6 md:h-6"
                        style={{
                          filter:
                            'invert(78%) sepia(38%) saturate(560%) hue-rotate(2deg) brightness(1.05) contrast(0.95) drop-shadow(0 0 8px rgba(212,175,55,0.35))',
                        }}
                      />
                    </div>

                    <div className="flex-1 min-w-0">
                      <div className="font-display text-base md:text-lg text-white tracking-wide uppercase leading-tight">
                        {b.name}
                      </div>
                      <div className="font-ui text-[11px] md:text-xs text-white/50 mt-1 leading-snug">
                        {b.desc}
                      </div>
                    </div>

                    <div className="bonus-value font-display">
                      {b.value}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* RIGHT — luxury framed hero photo */}
        <div className="col-span-12 md:col-span-5">
          <Reveal delay={200}>
            <div className="bonus-hero-frame" data-testid="bonus-hero">
              <div className="bonus-hero-inner">
                <img
                  src="/source-pptx/image74.jpeg"
                  alt="Erfolgreicher Geschäftsaufbau"
                  loading="lazy"
                  draggable={false}
                  className="block w-full h-auto object-cover select-none"
                  style={{ aspectRatio: '4/3.4' }}
                />
                <div className="bonus-hero-overlay" aria-hidden />
                <div className="bonus-hero-corner bonus-hero-corner--tl" aria-hidden />
                <div className="bonus-hero-corner bonus-hero-corner--tr" aria-hidden />
                <div className="bonus-hero-corner bonus-hero-corner--bl" aria-hidden />
                <div className="bonus-hero-corner bonus-hero-corner--br" aria-hidden />
              </div>
              <div className="bonus-hero-caption">
                <span className="bonus-hero-caption-label">STIG ROCK</span>
                <span className="bonus-hero-caption-sep" aria-hidden />
                <span className="bonus-hero-caption-body">
                  {t.business.sub}
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </SectionShell>
  );
}
